import * as CreDtos from "../CRE.dtos";

export const
    NEWS_REQUEST = "NEWS_REQUEST",
    NEWS_REQUEST_FAILURE = "NEWS_REQUEST_FAILURE",
    NEWS_REQUEST_SUCCESS = "NEWS_REQUEST_SUCCESS",
    NEWS_FILTER = "NEWS_FILTER",
    NEWS_ADD = "NEWS_ADD",
    NEWS_EDIT = "NEWS_EDIT",
    NEWS_CANCEL = "NEWS_CANCEL",
    NEWS_UPSERT_REQUEST = "NEWS_UPSERT_REQUEST",
    NEWS_UPSERT_REQUEST_FAILURE = "NEWS_UPSERT_REQUEST_FAILURE",
    NEWS_UPSERT_REQUEST_SUCCESS = "NEWS_UPSERT_REQUEST_SUCCESS"

export function newsRequest() {
    return {
        type: NEWS_REQUEST
    };
}

export function newsRequestSuccess(news: CreDtos.News[]) {
    return {
        type: NEWS_REQUEST_SUCCESS,
        news
    };
}

export function newsRequestFailure(error) {
    return {
        type: NEWS_REQUEST_FAILURE,
        error
    };
}

export function newsFilter(search: string, showDisabled: boolean) {
    return {
        type: NEWS_FILTER,
        search,
        showDisabled
    }
}

export function newsAdd() {
    return {
        type: NEWS_ADD
    }
}

export function newsEdit(news: CreDtos.News) {
    return {
        type: NEWS_EDIT,
        news
    }
}

export function newsCancel() {
    return {
        type: NEWS_CANCEL
    }
}

export function newsUpsertRequest(news: CreDtos.News) {
    return {
        type: NEWS_UPSERT_REQUEST,
        news
    };
}

export function newsUpsertRequestSuccess(news: CreDtos.News) {
    return {
        type: NEWS_UPSERT_REQUEST_SUCCESS,
        news
    };
}

export function newsUpsertRequestFailure(error) {
    return {
        type: NEWS_UPSERT_REQUEST_FAILURE,
        error
    };
}




// WEBPACK FOOTER //
// ./src/actions/news.actions.ts